import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=2bf8bde0&scoped=true&lang=css"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/my/company_intro/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf8bde0"]])

export default __exports__